/* istanbul ignore file */
/* eslint-disable react/display-name */
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
interface CounterProps {
  maxSeconds: number;
  onMaxReached: (value: boolean) => void;
}
interface CounterHandle {
  action: (action: string) => void;
}

const Counter: React.ForwardRefRenderFunction<CounterHandle, CounterProps> = (
  { maxSeconds, onMaxReached }: CounterProps,
  ref,
) => {
  const [totalSecondsPassed, setTotalSecondsPassed] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(0);
  const [currentStatus, setCurrentStatus] = useState<string>('pause');

  useEffect(() => {
    if (totalSecondsPassed === maxSeconds) {
      onMaxReached(true);
      setCurrentStatus('pause');
    }
    const intervalId: ReturnType<typeof setInterval> = setInterval(() => {
      if (currentStatus === 'start') {
        if (seconds === 59) {
          setSeconds(0);
          setMinutes(minutes + 1);
        } else {
          setSeconds(seconds + 1);
        }
        setTotalSecondsPassed(totalSecondsPassed + 1);
      } else if (currentStatus === 'restart') {
        console.log('enter restart');
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [currentStatus, maxSeconds, minutes, onMaxReached, seconds, totalSecondsPassed]);

  useImperativeHandle(ref, () => ({
    action(action: string) {
      if (action === 'restart') {
        setSeconds(0);
        setMinutes(0);
        setTotalSecondsPassed(0);
        setCurrentStatus('start');
      } else {
        setCurrentStatus(action);
      }
    },
  }));

  return (
    <div className="absolute bg-white px-2 rounded-md flex items-center select-none" style={{ top: 20, right: 30 }}>
      <div className="w-2 h-2 bg-red-500 rounded-full mr-1"></div>
      <div className="text-sm cursor-default">
        {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
      </div>
    </div>
  );
};

export default forwardRef(Counter);
